import { createReducer, on } from '@ngrx/store';
import { AnalyticActions } from './analytic.actions';
import { AnalyticState, analyticState } from './analytic.state';

export const analyticReducer = createReducer(
  analyticState,
  on(
    AnalyticActions.log,
    (state, args): AnalyticState => ({ ...state, ...args })
  )
);
